module.exports = __webpack_public_path__ + "img/map_popup.d37a1f3.svg";